export default "__VITE_ASSET__Q7IS2DVB__"